module.exports = __webpack_public_path__ + "2d4d5a413f1f4e1b5d3abac84b294bac.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/8_G2.mp3
// module id = 65
// module chunks = 0